// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import DynamicFormPayloadResourceViewModel from '../../../../viewModel/resource/DynamicFormPayloadResourceViewModel';
import PostDigitalDonationReceiptFormRequestViewModel from '../../../../viewModel/resource/PostDigitalDonationReceiptFormRequestViewModel';
import PostDigitalDonationReceiptFormRequestDTO from '../../dto/resource/PostDigitalDonationReceiptFormRequestDTO';

export default abstract class PostDigitalDonationReceiptFormRequestModel extends BaseModel<PostDigitalDonationReceiptFormRequestDTO> {
  /**
  */
  get appSystemKey() { return this.dto.appSystemKey; }
  set appSystemKey(value) { this.dto.appSystemKey = value; }
  /**
  */
  get form() { return this.getObjectModel(() => this.dto.form, DynamicFormPayloadResourceViewModel)!; }
  set form(value) { this.setObjectModel(() => this.dto.form, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.appSystemKey = qs.appsystemkey;
  }
}
